export const TEXT = {
  DESCRIPTION:
    'ERGO Lebensversicherung AG, ERGO Versicherung AG, DKV Deutsche Krankenversicherung AG, ERGO Beratung und Vertrieb AG, ERGO Krankenversicherung AG, ERGO Direkt Versicherung AG, ERGO Life S.A., ERGO Vorsorge Lebensversicherung AG, ERGO Reiseversicherung AG, ERGO Direkt AG',
} as const;
